import React from 'react'
import { Theme, useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const BestNewcomerIcon: React.FC<IIconProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <svg
      id='Capa_1' enableBackground='new 0 0 512 512' height={props.width} fill={theme.palette.text.primary}
      viewBox='0 0 512 512' width={props.width} xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='m488.207 256 21.219-36.418-30.61-28.997 10.043-40.953-37.563-19.13-1.907-42.089-41.392-7.83-13.599-39.88-41.95 4.087-24.309-34.458-39.091 15.813-33.048-26.145-33.046 26.145-39.09-15.814-24.31 34.458-41.95-4.087-13.599 39.881-41.392 7.829-1.906 42.089-37.564 19.13 10.043 40.953-30.61 28.997 21.217 36.419-21.219 36.418 30.61 28.997-10.043 40.953 37.564 19.13 1.906 42.089 41.392 7.83 13.599 39.88 41.95-4.087 24.31 34.458 39.09-15.813 33.048 26.145 33.046-26.145 39.09 15.814 24.31-34.458 41.95 4.087 13.599-39.881 41.392-7.83 1.907-42.089 37.564-19.13-10.043-40.953 30.61-28.997zm-232.207 183.478c-101.17 0-183.478-82.308-183.478-183.478s82.308-183.478 183.478-183.478 183.477 82.308 183.477 183.478-82.307 183.478-183.477 183.478z'
      />
      <path
        d='m256 102.556c-84.61 0-153.444 68.835-153.444 153.444s68.834 153.444 153.444 153.444c84.609 0 153.444-68.835 153.444-153.444s-68.836-153.444-153.444-153.444zm-73.44 204.461-32.003-25.028 6.511 30.475-22.041 4.709-14.332-67.083 18.591-3.972 32.003 25.029-6.511-30.475 22.041-4.71 14.332 67.083zm34.306-7.329-14.333-67.083 54.529-11.651 3.645 17.058-32.296 6.9 1.68 7.858 28.366-6.061 3.48 16.292-28.366 6.06 1.884 8.817 33.542-7.167 3.645 17.058zm156.014-33.335-24.246 5.18-18.487-33.527-3.746 38.277-24.246 5.181-35.8-62.496 23.288-4.975 19.841 35.643 4.213-40.782 20.796-4.443 19.944 36.122 4.11-41.262 21.466-4.587z'
      />
    </svg>
  )
}
export default BestNewcomerIcon
